'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


var initialState = {
    active: false,
    appendMode: false,
    top: null,
    left: null,
    width: null,
    height: null
};

exports.default = function (DecoratedComponent) {
    var SelectionMarqueeStateManager = function (_React$Component) {
        _inherits(SelectionMarqueeStateManager, _React$Component);

        function SelectionMarqueeStateManager(props) {
            _classCallCheck(this, SelectionMarqueeStateManager);

            var _this = _possibleConstructorReturn(this, (SelectionMarqueeStateManager.__proto__ || Object.getPrototypeOf(SelectionMarqueeStateManager)).call(this, props));

            _this.startMarqueeSelect = function (_ref) {
                var x = _ref.x,
                    y = _ref.y,
                    _ref$appendMode = _ref.appendMode,
                    appendMode = _ref$appendMode === undefined ? false : _ref$appendMode;

                _this.startPosition = { x: x, y: y };
                _this.setState({ active: true, left: x, top: y, appendMode: appendMode });
                _this.props.setSelectionMarqueeActive(true);
            };

            _this.dragMarqueeSelectionTo = function (_ref2) {
                var x = _ref2.x,
                    y = _ref2.y;

                var dx = x - _this.startPosition.x;
                var dy = y - _this.startPosition.y;

                var width = Math.abs(dx);
                var height = Math.abs(dy);
                var left = dx < 0 ? x : _this.startPosition.x;
                var top = dy < 0 ? y : _this.startPosition.y;

                _this.setState({ left: left, top: top, width: width, height: height });
            };

            _this.finishMarqueeSelect = function () {
                _this.setState(initialState);
                _this.props.setSelectionMarqueeActive(false);
            };

            _this.state = initialState;

            _this.startPosition = {
                x: null,
                y: null
            };
            return _this;
        }

        // Methods to update the state


        _createClass(SelectionMarqueeStateManager, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
                    startMarqueeSelect: this.startMarqueeSelect,
                    dragMarqueeSelectionTo: this.dragMarqueeSelectionTo,
                    finishMarqueeSelect: this.finishMarqueeSelect }));
            }
        }]);

        return SelectionMarqueeStateManager;
    }(_react2.default.Component);

    SelectionMarqueeStateManager.propTypes = {
        setSelectionMarqueeActive: _propTypes2.default.func
    };

    return SelectionMarqueeStateManager;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/selection/selectionMarqueeStateDecorator.js
// module id = 1698
// module chunks = 0